import {
	Button,
	DataTable,
	DataTableCell,
	DataTableColumn,
	Tabs,
	TabsPanel
} from '@salesforce/design-system-react';
import RecordHome from 'lib/RecordHome';
import * as React from 'react';
import { CloudName } from 'lib/types';

const day = 86400000;
const dateOptions = {month: '2-digit', day: '2-digit', year: 'numeric'};
const date = (offset: number) => (new Date(Date.now() - (offset * day))).toLocaleString('en-US', dateOptions);

// Styles for the cloud circles
const iconStyle = {marginTop: '-4px', marginLeft: '-4px', marginRight: '4px'};

type ProfileSource = {
	source: {
		name: string,
		cloud: CloudName
	}
	object: string
	id: string
	txn: string
	name: string
	email: string
	// tslint:disable-next-line:no-any
	phone: any // This is JSX, dunno how to type that at the moment
};
const SourceCell: React.SFC<{item?: ProfileSource}> = ({children, ...props}) => {
	const item = props.item || {source: {cloud: '', name: ''}};
	const img = `/assets/icons/${item.source.cloud}-circle.svg`;

	return (
		<DataTableCell {...props}>
			<img src={img} width="16" style={iconStyle} />
			{item.source.name}
		</DataTableCell>
	);
};
SourceCell.displayName = DataTableCell.displayName;

class Profile extends React.Component<{}> {

	render () {
		const sourceNameStyle = {marginLeft: '4px', marginRight: '12px'};
		const sources = (
			<span>
				<span style={sourceNameStyle}>
					<img src="/assets/icons/commerce-circle.svg" width="16" style={iconStyle} />
					Commerce (1)
				</span>
				<span style={sourceNameStyle}>
					<img src="/assets/icons/marketing-circle.svg" width="16" style={iconStyle} />
					Marketing (1)
				</span>
				<span style={sourceNameStyle}>
					<img src="/assets/icons/service-circle.svg" width="16" style={iconStyle} />
					Service (3)
				</span>
				<br />
				<span style={sourceNameStyle}>
					<img src="/assets/icons/sales-circle.svg" width="16" style={iconStyle} />
					Sales (1)
				</span>
				<span style={sourceNameStyle}>
					<img src="/assets/icons/mulesoft-circle.svg" width="16" style={iconStyle} />
					Point-of-Sale (1)
				</span>
			</span>
		);

		const details = [
			{ label: 'Customer 360 ID', content: 'MD33DCF54ED023392' },
			{ label: 'Contributing Records', content: '7' },
			{ label: 'Contributing Sources', content: sources },
			{ label: 'Last Modified', content: new Date(Date.now()).toLocaleDateString() },
		];

		const profileSources: ProfileSource[] = [
			{	source: { name: 'Commerce', cloud: 'commerce' },
				object: 'Profile', id: '00330000011DhJj',
				txn: date(0),
				name: 'F. Muessig', email: 'fmuessig@email.de',
				phone: (<div> <p>+49 (0) 8137 858644</p> </div>),
			},
			{	source: { name: 'Service', cloud: 'service' },
				object: 'Person Account', id: '00330000011DdIo',
				txn: date(0),
				name: 'Fabian Muessig', email: 'fabian38928@mail.com',
				phone: ( <div> <p>+49 (0) 4150 960568</p> </div>)
			},
			{	source: { name: 'Marketing', cloud: 'marketing' },
				object: 'Subscriber', id: '70411390',
				txn: date(1),
				name: 'F. Muessig', email: 'f.muessig@gmail.com',
				phone: (<div> <p>+49 (0) 2577 15864</p> </div>),
			},
			{	source: { name: 'Service', cloud: 'service' },
				object: 'Person Account', id: '00390000013Xfiu0',
				txn: date(2),
				name: 'Fabian Muessig', email: 'fabian.muessig@yahoo.com',
				phone: ( <div> <p>+49 (0) 2277 147866</p> </div>)
			},
			{	source: { name: 'Service', cloud: 'service' },
				object: 'Person Account', id: '00000042012WdIo',
				txn: date(3),
				name: 'Fabian Muessig', email: 'f.muessig@gmail.com',
				phone: ( <div> <p>+49 (0) 5249 137335</p> </div>)
			},
			{	source: { name: 'Sales', cloud: 'sales' },
				object: 'Contact Record', id: '00030000099112x',
				txn: date(3),
				name: 'Fabian Muessig', email: 'fabian.muessig@outlook.com',
				phone: ( <div> <p>+49 (0) 5597 838194</p> </div>)
			},
			{	source: { name: 'Point-of-Sale', cloud: 'mulesoft' },
				object: 'Order Record', id: '0000000113456',
				txn: date(0),
				name: 'Fabian Muessig', email: 'fabian.muessig@gmail.com',
				phone: (<span>&nbsp;</span>)
			},
		];

		return (
			<div className="stewardship-profile-sources">
				<RecordHome
					buttons={[<Button key="1" label="Edit" />]}
					details={details}
					page={<span>Customer Profile</span>}
					section={<a href="javascript:void(0);">Data Stewardship</a>}
					title="Fabian Müessig"
				/>
				<div className="slds-box slds-m-top_small">
					<Tabs defaultSelectedIndex={1}>
						<TabsPanel label="Attributes" />
						<TabsPanel label="Source Records" />
						<TabsPanel label="Change History" />
					</Tabs>
					<div className="slds-box">
						<strong className="slds-text-heading_small slds-text-small">Source Records</strong>
						<DataTable items={profileSources}>
							<DataTableColumn label="Data Source" key="source" property="source">
								<SourceCell />
							</DataTableColumn>
							<DataTableColumn label="Source Object" key="object" property="object" />
							<DataTableColumn label="Record ID" key="id" property="id" />
							<DataTableColumn label="Last Transaction" key="txn" property="txn" />
							<DataTableColumn label="Name" key="name" property="name" />
							<DataTableColumn label="Email" key="email" property="email" />
							<DataTableColumn label="Phone" key="phone" property="phone" />
						</DataTable>
					</div>
				</div>
			</div>
		);
	}
}

export default Profile;



// WEBPACK FOOTER //
// ./src/DataStewardship/profile.tsx